import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="flex min-h-[50vh] items-center justify-center pb-12" data-testid="payment-cancel-page">
      <div className="max-w-md rounded-3xl border border-neutral-200 bg-white p-8 text-center">
        <XCircle className="mx-auto h-12 w-12 text-neutral-400" />
        <h1 className="mt-4 text-xl font-medium text-neutral-900">
          Payment cancelled
        </h1>
        <p className="mt-2 text-sm text-neutral-600">
          No worries — your cart is still saved. You can pick up where you left
          off whenever you&apos;re ready.
        </p>
        <Link
          to="/checkout"
          className="mt-6 inline-flex h-10 items-center justify-center rounded-full bg-black px-8 text-[11px] font-medium uppercase tracking-[0.25em] text-white hover:bg-neutral-800"
          data-testid="cancel-retry"
        >
          Return to checkout
        </Link>
      </div>
    </div>
  );
}
